import { render, staticRenderFns } from "./PollIcon.vue?vue&type=template&id=86b3f4ca&scoped=true"
import script from "./PollIcon.vue?vue&type=script&lang=js"
export * from "./PollIcon.vue?vue&type=script&lang=js"
import style0 from "./PollIcon.vue?vue&type=style&index=0&id=86b3f4ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b3f4ca",
  null
  
)

export default component.exports